/* eslint func-style: "off" */
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';

import {
  GENERATE_EMBED_CODE,
  generateEmbedCodeSucceeded,
  generateEmbedCodeFailed,
} from './WidgetEmbedModal.ducks';
import apiClient from '../../helpers/apiClient';

export const generateEmbedCode = function* (action) {
  try {
    const fetchOptions = {
      method: 'POST',
      body: JSON.stringify(action.payload)
    };
    const payload = yield call(apiClient, '/api/generate-embedded-widget', fetchOptions);
    yield put(generateEmbedCodeSucceeded(payload));
  } catch (e) {
    yield put(generateEmbedCodeFailed(e));
  }
};

export const generateEmbedCodeSaga = function* () {
  yield takeLatest(GENERATE_EMBED_CODE, generateEmbedCode);
};

const sagas = function* () {
  yield all([
    fork(generateEmbedCodeSaga)
  ]);
};

export default sagas;


